<template>
  <div>
    <v-divider/>
    <v-list-tile :style="active">
      <v-list-tile-content :style="activeText">{{template.templateName}}</v-list-tile-content>
      <v-list-tile-action>
        <v-menu top left offset-y ref="templateItemAction">
          <v-btn :id="templateActionBtnId(templateKey)" :aria-label="templateActionBtnId(templateKey)" slot="activator" icon>
            <v-icon>more_vert</v-icon>
          </v-btn>
          <v-list role="menu" class="py-0">
            <v-list-tile @click="clickDelete">
              <v-list-tile-title :id="templateDeleteId" :aria-label="templateDeleteId">
                <v-icon class="pr-2">delete</v-icon>
                {{$t('admin.alerts.new.email_templates.delete')}}
              </v-list-tile-title>
            </v-list-tile>

            <v-list-tile @click="clickVisibility">
              <v-list-tile-title :id="templateVisibilityId" :aria-label="templateVisibilityId">
                <div v-if="!visible">
                  <v-icon class="pr-2">visibility_off</v-icon>
                  {{$t('admin.alerts.new.email_templates.show')}}
                </div>
                <div v-else>
                  <v-icon class="pr-2">visibility</v-icon>
                  {{$t('admin.alerts.new.email_templates.hide')}}
                </div>
              </v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-list-tile-action>
    </v-list-tile>
  </div>
</template>
<script>
  import { SET_TEMPLATE_ITEM_VISIBILITY } from '../../../store/mutation-types'
  import { DELETE_EMAIL_TEMPLATE_ITEM } from '../../../store/action-types'

  export default {
    name: 'alert-template-item',
    data () {
      return {
        activeWidth: '5px',
        activeTransition: 'all 0.3s ease-in-out'
      }
    },
    props: {
      template: {
        type: Object
      },
      templateKey: {
        type: Number
      },
      panelColour: {
        type: Object
      }
    },
    methods: {
      templateActionBtnId (key) {
        return `template-action-${key}`
      },
      clickVisibility () {
        this.$store.commit(SET_TEMPLATE_ITEM_VISIBILITY, {key: this.templateKey, visible: !this.visible})
      },
      clickDelete () {
        let payload = {
          id: this.template.id,
          toBeDeleted: true
        }
        this.$store.dispatch(DELETE_EMAIL_TEMPLATE_ITEM, payload)
      }
    },
    computed: {
      visible () {
        return this.template.visible
      },
      active () {
        if (this.visible) {
          return {
            borderLeft: `solid ${this.activeWidth} ${this.panelColour.backgroundColor}`,
            transition: this.activeTransition
          }
        }
      },
      activeText () {
        if (this.visible) {
          return {
            marginLeft: `-${this.activeWidth}`,
            transition: this.activeTransition
          }
        }
      },
      templateVisibilityId () {
        return `template-visibility-btn-${this.templateKey}`
      },
      templateDeleteId () {
        return `template-delete-btn-${this.templateKey}`
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/settings/alert/AlertTemplateItem.vue